import { get } from "core-web/libs/GrebbCommerceAPI/util";
import { getModel } from "core-web/state";

export default async (id, parameters = {}) => {
    const response = await get(`/frontend/product/${id}/relations`, {
        application_id: getModel("application").applicationId,
        ...parameters,
    });

    return await response.body();
};
